
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConductDetailFormsTableConfig } from './conduct-detail.table-config';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { ClientService, ConductService, FormGroupService, FormService, LocalStorageService, SurveyService } from '@app/services';
import { FormBuilderService } from '@app/form-builder/form-builder/form-builder-service.service';
import { FormStateService } from '@app/form-builder/form-builder/form-state.service';
import { AppNotification } from '@app/helpers';

@Component({
  selector: 'app-conduct-detail',
  templateUrl: './conduct-detail.component.html',
  styleUrls: ['./conduct-detail.component.scss']
})
export class ConductDetailComponent implements OnDestroy {
  tableConfig: any;
  surveyId: string | null;
  surveyName: string | null;
  formList: any[] = [];
  selectedForm: any;
  conductId: string | null;
  conductName: string = "";
  isLoading: boolean = false;
  clientId: string | null;
  conductReport: boolean = false;
  surveyDetails: any;

  groupList: any[] = [];
  groupForms: Record<string, any[]> = {};
  selectedGroup: any;
  selectedGroupRow: number|null;

  formAndGroupList: any[] = [];
  isLocked: boolean = false;

  currentUserRole: string;
  clientDetails: any;
  reportPopup: boolean = false;

  alertFormDelete: any = {
    visible: false,
    item: null
  }

  autoSaveTimerRef: any;
  isArchived: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formService: FormService,
    private formBuilderService: FormBuilderService,
    public formStateService: FormStateService,
    private conductService: ConductService,
    private formGroupService: FormGroupService,
    private clientService: ClientService,
    private surveyService: SurveyService
  ) { }

  ngOnDestroy(): void {
    clearTimeout(this.autoSaveTimerRef);
  }

  ngOnInit(): void {
    this.surveyId = this.route.snapshot.queryParamMap.get('surveyId');
    this.conductId = this.route.snapshot.queryParamMap.get('conductId');
    this.clientId = this.route.snapshot.queryParamMap.get('clientId');

    this.currentUserRole = LocalStorageService.getUserRole();

    if (this.conductId == null && (this.surveyId == null || this.clientId == null)) {
      this.router.navigate([APP_ROUTES.CONDUCT])
      return
    }

    this.tableConfig = ConductDetailFormsTableConfig.configure()
    this.formStateService.flushState()
    if (this.conductId == null) {
      (async () => {
        await this.getClientDetails();
        this.getFormList();
        this.getGroups();
        this.getSurveyDetails();
      })()
    } else {
      this.getConductInfo();
    }
  }

  setAutoSaveTimer() {
    console.log("save  save save", this.autoSaveTimerRef)
    if (this.autoSaveTimerRef != null) return;
    this.autoSaveTimerRef = setTimeout(() => {
      this.onSaveHandler();
      this.autoSaveTimerRef = null;
    }, 2000)
  }

  async getSurveyDetails() {
    return new Promise((resolve, reject) => {
      this.surveyService.info(this.surveyId!).subscribe({
        next: (res: any) => {
          this.surveyDetails = res.data;
          this.conductName = `${this.surveyDetails.name} #1`
          this.surveyName = this.surveyDetails.name
          resolve(res);
        },
        error: (error: any) => {
          reject(error);
        }
      })
    })
  }

  async getClientDetails() {
    return new Promise((resolve, reject) => {
      this.clientService.info(this.clientId).subscribe({
        next: (res: any) => {
          this.clientDetails = res.data;
          resolve(res);
        },
        error: (error: any) => {
          reject(error);
        }
      })
    })
  }

  getFormList() {
    this.isLoading = true;
    this.formService.list(this.surveyId).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.groupForms = {};
        res.data.forEach((form: any) => {
          if (!form.groupId) {
            this.formList.push(form)
            return
          }

          if (!this.groupForms[form.groupId]) {
            this.groupForms[form.groupId] = []
          }
          this.groupForms[form.groupId].push(form)
        })
        this.formAndGroupList = this.formList.concat(this.groupList).sort((a, b) => (a.seqNo - b.seqNo))
        if (res.data.length) this.selectForm(this.formList[0])
        this.constructFormState();
      }
    })
  }

  gridActions(e: any) {
    if (e.button?.eventName == "edit") {
      this.router.navigate([APP_ROUTES.FORM_BUILDER], {
        queryParams: { formId: e.data._id }
      })
    }
    if (e.button?.eventName == "add") {
      this.router.navigate([APP_ROUTES.FORM_BUILDER], {
        queryParams: { surveyId: this.surveyId }
      })
    }
    if (e.button?.eventName == "save") {
      this.onSaveHandler();
    }
    if (e.eventName == "row-selected") {
      this.selectForm(e.data)
    }
    if (e.button?.eventName == "download") {
      this.downloadConduct(e.button?.eventName);
    }
    if (e.button?.eventName == "select-group") {
      this.selectGroupRow(e.data, e.row)
    }
    if (e.button?.eventName == "lock") {
      this.lockConduct(true)
    }
    if (e.button?.eventName == "unlock") {
      this.lockConduct(false)
    }
    if (e.button?.eventName == "archive") {
      this.archiveConduct(true)
    }
    if (e.button?.eventName == "unarchive") {
      this.archiveConduct(false)
    }
    if (e.button?.eventName == "copy-link") {
      this.copyLinkToClip();
    }
    if (e.button?.eventName == "email-link") {
      this.sendConductToclient();
    }
  }

  archiveConduct(archive: boolean) {
    if (!this.conductId) return;
    this.conductService.archive(this.conductId!, archive).subscribe({
      next: (res: any) => {
        AppNotification.success('Done');
        this.isArchived = archive;
      },
      error: (error) => {
        AppNotification.success('Some Error!');
      }
    })
  }


  lockConduct(lock: boolean) {
    if (!this.conductId) return;
    this.conductService.lock(this.conductId!, lock).subscribe({
      next: (res: any) => {
        AppNotification.success('Done');
        this.isLocked = lock;
      },
      error: (error) => {
        AppNotification.success('Some Error!');
      }
    })
  }

  selectForm(formObj: any) {
    this.selectedGroup = null;
    this.selectedForm = formObj
    try {
      let formJson: any = JSON.parse(formObj.formJson)

      this.formBuilderService.components = formJson.added_components;
      this.formBuilderService.formDesign = formJson.form_design;
      this.formBuilderService.onChangeHandler = ")";

      this.selectedForm.content = this.formBuilderService.generateHtml();
      this.selectedForm.parsedFormJson = formJson
      // for(let ele of document.getElementsByTagName('input').) {

      // }
    } catch (error) {
      console.log(error)
    }
  }

  constructFormState() {
    for (let formObj of this.formList) {
      try {
        let formJson: any = JSON.parse(formObj.formJson)
        // this.formBuilderService.formJsonFixer(formJson);
        if (formJson.form_design.formType == 'recursive') {
          this.formStateService.addRecursiveFormState(formJson, formObj._id)
          continue;
        }
        this.formStateService.addFormState(formJson, formObj._id)

      } catch (error) {
        console.log(error)
      }
    }
    this.formStateService.addClientDetails(this.clientDetails);
    console.log(this.formStateService.formState)
  }

  onChangeEmitter(e: any) {
    if(e.eventType == "ConfirmRemoveRecursiveForm") {
      this.alertFormDelete = {
        visible: true,
        item: e,
        success: () => {
          this.onChangeEmitter({
            eventType: "RemoveRecursiveForm",
            formId: e.formId,
            formRow: e.formRow
          })
        }
      }
      return
    }
    this.setAutoSaveTimer();
    console.log("--", e)
    let formId, formRow;
    formId = this.selectedForm?._id;
    if (this.selectedGroup) {
      formId = this.selectedGroup._id
      formRow = this.selectedGroupRow;
    }
    if (!this.selectedGroup && this.selectedForm.parsedFormJson.form_design.formType == 'recursive') {
      formId = this.selectedForm._id
      formRow = e.formRow
    }
    this.formStateService.stateChange({
      component: e.component,
      eventType: e.eventType,
      row: e.row,
      col: e.col,
      value: e.value,
      formId: formId,
      formRow: formRow ?? e.formRow
    })
  }

  onSaveHandler() {
    // console.log(this.formStateService.formState)
    // return;
    if (this.conductId != null) {
      return this.conductService.update(this.conductId, {
        name: this.conductName,
        formState: this.formStateService.formState,
      }).subscribe({
        next: (res: any) => {
          AppNotification.success('Saved!')
        },
        error: () => {
          AppNotification.success('Some error occured!')
        }
      })
    }

    let forms = this.formList.map((o: any) => o._id)

    if (this.groupForms) {
      Object.values(this.groupForms).forEach((o: any) => {
        forms.push(...(o.map((i: any) => i._id)))
      })
    }

    return this.conductService.add({
      name: this.conductName,
      forms: forms,
      formState: this.formStateService.formState,
      formGroups: this.groupList.map((o: any) => o._id),
      survey: this.surveyId,
      client: this.clientId
    }).subscribe({
      next: (res: any) => {
        this.conductId = res.data._id
        AppNotification.success('Saved!')
        this.router.navigate([APP_ROUTES.CONDUCT_DETAILS], {
          replaceUrl: true,
          queryParams: { conductId: res.data?._id }
        })
      },
      error: () => {
        AppNotification.success('Some error occured!')
      }
    })
  }

  getConductInfo() {
    this.isLoading = true;
    this.conductService.info(this.conductId!).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.clientDetails = res.data.client
        this.conductName = res.data.name
        this.surveyName = res.data.survey.name
        this.formStateService.formState = res.data.formState;
        this.isLocked = res.data.locked;
        this.isArchived = res.data.archived;
        // this.formList = res.data.forms
        this.groupForms = {};
        this.groupList = res.data.formGroups.map((o: any) => {
          o.group = true;
          return o
        });
        res.data.forms.forEach((form: any) => {
          if (!form.groupId) {
            this.formList.push(form)
            return
          }

          if (!this.groupForms[form.groupId]) {
            this.groupForms[form.groupId] = []
          }
          this.groupForms[form.groupId].push(form)
        })

        this.surveyId = res.data.survey._id

        this.formAndGroupList = this.formList.concat(this.groupList).sort((a, b) => (a.seqNo - b.seqNo))
        this.selectForm(this.formList[0])
      },
      error: () => { }
    })
  }

  // conductPDF: any = "";

  downloadConduct(type: string) {
    if (this.conductId == null) {
      return;
    }
    // this.conductReport = true;
    this.isLoading = true;
    this.conductService.download(this.conductId!, type).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        window.open(URL.createObjectURL(res))
        // this.conductPDF = URL.createObjectURL(res);
      },
      error: (err) => {
        AppNotification.error('Something went wrong!')
      }
    })
  }

  getGroups() {
    this.formGroupService.list(this.surveyId!).subscribe({
      next: (res: any) => {
        this.groupList = res.data.map((o: any) => {
          o.group = true;
          return o
        })
        this.formAndGroupList = this.formList.concat(this.groupList).sort((a, b) => (a.seqNo - b.seqNo))
      },
      error: console.log
    })
  }

  addGroupForm(group: any) {
    this.formStateService.stateChange({
      eventType: "AddRecursiveForm",
      formId: group._id,
      value: group.name
    })
  }

  selectGroupRow(group: any, row: number) {
    this.selectedForm = null;
    this.selectedGroupRow = row;
    group.forms = this.groupForms[group._id] || []
    group.forms.sort((a: any, b: any) => a.seqNo - b.seqNo)
    for (let form of group.forms) {
      form.parsedFormJson = JSON.parse(form.formJson);
    }
    this.selectedGroup = group;
  }

  onFileSelected(event: any, group: any, groupRow: any, form: any) {
    if (!event?.target?.files?.[0]) return;
    this.onChangeEmitter({
      value: event.target.files[0],
      eventType: "addFile",
      component: {
        element: {
          field_name: form._id
        }
      }
    })
  }

  onFileComment(event: any, index: any, group: any, groupRow: any, form: any) {
    this.onChangeEmitter({
      value: event.value,
      row: index,
      eventType: "addComment",
      component: {
        element: {
          field_name: form._id
        }
      }
    })
  }

  onFileDelete() {
    let selected = this.alertFormDelete.item
    this.onChangeEmitter({
      value: null,
      row: selected.i,
      eventType: "removeFile",
      component: {
        element: {
          field_name: selected.form._id
        }
      }
    })
  }

  openImageDeletePopup(i: any, selectedGroup: any, selectedGroupRow: any, form: any) {
    this.alertFormDelete = {
      visible: true,
      item: {
        i, selectedGroup, selectedGroupRow, form
      }
    }
  }

  copyLinkToClip() {
    navigator.clipboard.writeText(location.href);
    AppNotification.success('survey link copied!')
  }

  sendConductToclient() {
    if (!this.conductId) return
    this.conductService.sendEmail(this.conductId).subscribe({
      next: (res: any) => {
        AppNotification.success(`Sent to ${this.clientDetails?.user?.email ?? 'Client'}!`)
      },
      error: (err: any) => {
        AppNotification.error('something went wrong!')
      }
    })
  }

  checkExt(url: any) {
    let urlsSections = (url ?? "").split(".")
    let ext = urlsSections[urlsSections?.length - 1]
    return ext == 'png' || ext == 'jpg' || ext == 'jpeg'
  }

  deleteGroupedSurvey() {
    let selected = this.alertFormDelete.item
    this.onChangeEmitter({
      value: null,
      eventType: "removeGroup"
    })
    this.selectedGroupRow = null
    this.selectedGroup = null
  }

  openDeleteGroupedSurvey(groupId: string, groupRowIndex: number) {
    this.alertFormDelete = {
      visible: true,
      item: {
        groupId,
        groupRowIndex
      },
      success: () => {
        this.deleteGroupedSurvey()
      }
    }
  }
}

